import React from 'react';
import styles from './ASLVideoUploadNote.module.scss';

function ASLVideoUploadNote() {
  return (
    <div className={styles.fieldNoteSection}>
      <h2>Notes:</h2>
      <ol>
        <li className={styles.fieldNoteEach}>Select the ZIP file.</li>
        <li className={styles.fieldNoteEach}>
          Using the Extract File Button: Extract the video files from the ZIP
          file.
        </li>
        <li className={styles.fieldNoteEach}>
          Check for errors during the extraction process.
          <ul>
            <li className={styles.fieldNoteEach}>
              If no errors are found, proceed to the next step.
            </li>
          </ul>
        </li>
        <li className={styles.fieldNoteEach}>Upload the video files.</li>
        <li className={styles.fieldNoteEach}>
          Once the files are uploaded successfully, click on the "Video Upload
          History" tab to view them.
        </li>
      </ol>
    </div>
  );
}

export default ASLVideoUploadNote;
